import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin, InputNumber } from 'antd'
import { SGeneralForms, SModalSelected } from 'shj-components'
import { finAccountList, lendingInstitutionsSearch } from "@/services/fmsConfig";
import { httpDictServTenant, getEnum } from "@/services/fmsServices";
import dayjs from 'dayjs'
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
  const { editData, financialOrgCode } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [disabledState, setDisabledState] = useState(false)
  const [disabledFinAccount, setDisabledFinAccount] = useState(false) // 控制收款账户是否可编辑
  const [kdOutShow, setkdOutShow] = useState(false);
  const [finAccountArr, setFinAccountArr] = useState([]);
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])
  useImperativeHandle(ref, () => ({
    getValue: () => formRef.current?.onFormRef()?.getFieldsValue(),
    validateFields: () => formRef.current?.onFormRef()?.validateFields(),
  }));
  const initFn = async () => {
    if (editData) {
      setSpinning(true)
      editData.receivedClickDate = editData.receivedClickDate ? dayjs(editData.receivedClickDate) : undefined
      editData.receivedDate = editData.receivedDate ? dayjs(editData.receivedDate) : undefined
      editData.accountingDate = editData.accountingDate ? dayjs(editData.accountingDate) : undefined
      editData.creditFlag = (editData.creditFlag === true || editData.creditFlag === '1') ? true : false
      editData.customerReceiptFlag = (editData.customerReceiptFlag === true || editData.customerReceiptFlag === '1') ? true : false
      editData.kdOutBillNoFlag = (editData.kdOutBillNoFlag === true || editData.kdOutBillNoFlag == '1') ? true : false
      formRef.current?.onFormRef()?.setFieldsValue(editData)
      setSpinning(false)
      if(editData.state === 'receiveToAccount' || editData.state === 'confirmToAccount'){
        setDisabledState(true)
      }else{
        setDisabledState(false)
      }
      if(editData.state === 'confirmToAccount'){
        setDisabledFinAccount(true)
      }else{
        setDisabledFinAccount(false)
      }
      if (editData.kdOutBillNoFlag == '1' || editData.kdOutBillNoFlag === true) {
        setkdOutShow(true);
      } else {
        setkdOutShow(false);
      }
    }else{
      formRef.current?.onFormRef()?.setFieldsValue({
        customerReceiptFlag: true,
        printType: 'machinePrinting',
      })
    }
  }
  const getOptions = async () => {
    // const transactionJournalTypeLists: any = await httpDictServTenant({
    //   parentKey: 'transactionJournalType',
    //   enabled: 1,
    // })
    const finAccountLists:any = await finAccountList({
      fmsCompanyCode: financialOrgCode,
      enabled: 1
    })
    const lendingInstitutionsList:any = await lendingInstitutionsSearch({})
    finAccountLists.map((item)=>{
      item.name = item.accountName + '*' + item.cardNo.slice(-4) // 取cardNo后4位
    })
    // 打印方式
    const printTypeLists: any = await getEnum('com.shj.saas.plus.fms.enums.PrintTypeEnum') 
    //支付方式 去掉在线支付
    const paymentMethodLists: any = await httpDictServTenant({
      parentKey: 'paymentMethod',
      enabled: 1,
      orderBys: [
        {
          "columnName": "sortNumber",
          "asc": true
        }
      ]
    }).then((list: any) => list.filter((item) => item.priKey !== 'onlinePay'))
    //交易类型
    const transactionFeeTypeLists: any = await httpDictServTenant({
      parentKey: 'transactionFeeType',
      enabled: 1,
    })
    setFinAccountArr(finAccountLists)
    return Promise.resolve({
      // transactionJournalTypeLists,
      finAccountLists,
      printTypeLists,
      paymentMethodLists,
      transactionFeeTypeLists,
      lendingInstitutionsList,
    })
  }
  const setAmount = (e) =>{
    formRef.current?.onFormRef()?.setFieldsValue({
      verifiedAmount: 0,
      unverifiedAmount: e
    })
  }
  const onKdOutShow = (e: any) => {
    if (e) {
      let finAccountId;
      for (let m of finAccountArr) {
        if (m.accountName.indexOf('虚拟银行') != -1) {
          finAccountId = m.id;
        }
      }
      formRef.current?.onFormRef()?.setFieldsValue({
        finAccountId,
      })
    } else {
      formRef.current?.onFormRef()?.setFieldsValue({
        finAccountId: '',
      })
    }
    setkdOutShow(e);
  };
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        layout="vertical"
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '收款单号',
                name: 'transactionCode',
                isHideItem: !editData?.id,
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '支付方式',
                name: 'paymentMethod',
                spanCol: 8,
                type: 'select',
                data: 'paymentMethodLists',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                  // disabled: disabledState
                },
              },
              {
                label: '收款状态',
                name: 'stateName',
                isHideItem: !editData?.id,
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '收款日期',
                name: 'receivedDate',
                type: 'dateTime',
                required: true,
                spanCol: 8,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  // disabled: disabledState,
                  showTime: {
                    defaultValue: dayjs(),
                    format: 'HH:mm:ss'
                  }
                }
              },
              {
                label: '收款账户',
                name: 'finAccountId',
                spanCol: 8,
                type: 'select',
                data: 'finAccountLists',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'id', label: 'name' },
                  disabled: disabledFinAccount,
                  onChange: (value, option) => {
                    const selectedAccount = finAccountArr.find(item => item.id === value);
                    if (selectedAccount?.accountName?.includes('虚拟银行')) {
                      setkdOutShow(true);
                      formRef.current?.onFormRef()?.setFieldsValue({
                        kdOutBillNoFlag: true,
                      })
                    } else {
                      setkdOutShow(false);
                      formRef.current?.onFormRef()?.setFieldsValue({
                        kdOutBillNoFlag: false,
                      })
                    }
                  }
                },
              },
              {
                label: '付款账户',
                name: 'paymentAccount',
                spanCol: 8,
              },
              {
                label: '收款金额',
                name: 'amount',
                type: 'inputNumber',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                children: (
                  <InputNumber disabled={disabledState} placeholder='请输入收款金额' onChange={setAmount}/>
                )
              },
              
              {
                label: '已核销金额',
                name: 'verifiedAmount',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '未核销金额',
                name: 'unverifiedAmount',
                required: true,
                spanCol: 8,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '收据方式',
                name: 'printType',
                spanCol: 8,
                type: 'select',
                data: 'printTypeLists',
                comConfig: {
                  fieldNames: { value: 'key', label: 'description' },
                },
              },
              {
                label: '收据编号',
                name: 'printNo',
                isDeps: true,
                deps: [{ name: 'printType', value: 'handWriting' }],
                spanCol: 8,
              },
              {
                label: '收据编号',
                name: 'printNo',
                spanCol: 8,
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '打印状态',
                name: 'printStateName',
                spanCol: 8,
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '到账日期',
                name: 'accountingDate',
                type: 'dateTime',
                spanCol: 8,
                comConfig: {
                  showTime: {
                    defaultValue: dayjs(),
                    format: 'HH:mm:ss'
                  }
                }
              },
              {
                label: '确认收款操作时间',
                name: 'receivedClickDate',
                type: 'dateTime',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '交易类型',
                name: 'transactionType',
                spanCol: 8,
                type: 'select',
                data: 'transactionFeeTypeLists',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                  disabled: disabledState
                },
              },
              {
                label: '核销状态',
                name: 'verifyStateName',
                spanCol: 8,
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '是否客户收款',
                name: 'customerReceiptFlag',
                spanCol: 8,
                type: 'switch',
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
              {
                label: '是否贷款机构转入',
                name: 'creditFlag',
                spanCol: 8,
                type: 'switch',
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
              {
                label: '贷款机构',
                name: 'creditCode',
                isDeps: true,
                deps: [{ name: 'creditFlag', value: true }],
                spanCol: 8,
                type: 'select',
                data: 'lendingInstitutionsList',
                comConfig: {
                  fieldNames: { value: 'institutionNumber', label: 'institutionName' },
                },
              },
              {
                label: '是否已在金蝶系统录入收款单',
                name: 'kdOutBillNoFlag',
                type: 'switch',
                checkedChildren: "是",
                unCheckedChildren: "否",
                spanCol: 8,
                comConfig: {
                  onChange: onKdOutShow,
                }
              },
              {
                label: '金蝶系统收款单号',
                name: 'kdOutBillNo',
                isHideItem:!kdOutShow,
                spanCol: 8,
              },
              // {
              //   label: '贷款机构',
              //   name: 'creditCodeName',
              //   isDeps: true,
              //   deps: [{ name: 'creditFlag', value: true }],
              //   spanCol: 12,
              //   children:  (<SModalSelected
              //       inputButtonLabel="选择"
              //       selectType="table"
              //       inputName="levelName"
              //       config={config}
              //       modalProps={{
              //         title: '请选择贷款机构',
              //         cancelText: '取消',
              //         okText: '确定',
              //       }}
              //       getTableList={getTableList}
              //       onChange={getSelectedRow}
              //     />)
              // },
              {
                label: '备注',
                type: 'textarea',
                name: 'description',
                spanCol: 24,
                comConfig: {
                  maxLength: 50,
                },
              },
            ],
          },
        ]}
      />
    </Spin>
  )
})
